import { CwsA, CwsHeaderMegamenu, CwsHeaderMegamenuItem, CwsHeaderMenuNav, CwsHeaderMenuNavItem } from '@components/cws'
import { getSlug, SEPARATOR } from '@utils/slugs'
import Link from 'next/link'
import { CategoryTip } from '@model/category/CategoryTip'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/dist/client/router'
import { isGloballyPricelist } from '@utils/pricelist-utils/app-properties'
type CategoriesViewProps = {
  categories: CategoryTip[]
}
export const CategoriesView: FC<CategoriesViewProps> = ({ categories }) => {
  const { locale, query, asPath } = useRouter()
  const isCurrentCategory = useCallback(
    (categoryId: string) => {
      if (asPath.includes('category')) {
        const { slug } = query
        return typeof slug === 'string' && slug.endsWith(categoryId)
      }
      return false
    },
    [query, asPath]
  )

  const [categoryItems, setCategoryItems] = useState<CategoryTip[]>([])
  const prevLocale = useRef<string | undefined>()

  useEffect(() => {
    setCategoryItems(categories)
    prevLocale.current = locale
  }, [locale, categories])
  const baseUrl = isGloballyPricelist() ? `${locale}/${query.catalogId}` : `${locale}`
  if (!categoryItems.length) return null

  return (
    <>
      {prevLocale.current === locale && categoryItems.length ? (
        <CwsHeaderMenuNav>
          {categories.map((item) => {
            const icon = item.custom3
            const slug = getSlug(`${item.name}`, item.id)
            let href = `${baseUrl}/category/${slug}`

            if (item.searchKey === 'clubone') {
              href = `/${baseUrl}/collection/${item.description}`
            } else if (item.searchKey === 'brands') {
              href = `/${baseUrl}/brands`
            }
            const isNotification = item?.custom2 === 'campaign'
            return (
              <CwsHeaderMenuNavItem
                key={item.id}
                current={isCurrentCategory(item.id + '')}
                label={item.name}
                href={href}
                icon={icon}
                tagNotification={isNotification}
              >
                <CwsA href={href} />
                {item.children.length ? (
                  <CwsHeaderMegamenu>
                    {item.children
                      .filter((item) => !!item.children.length)
                      .map((subCategory) => {
                        const slug = getSlug(`${item.name}${SEPARATOR}${subCategory.name}`, subCategory.id)
                        if (!subCategory.children.length) return null

                        const href = isGloballyPricelist()
                          ? {
                              pathname: '/[catalogId]/category/[slug]',
                              query: { catalogId: query.catalogId, slug },
                            }
                          : {
                              pathname: '/category/[slug]',
                              query: { slug },
                            }

                        return (
                          <CwsHeaderMegamenuItem
                            key={slug}
                            title={
                              <Link href={href} passHref>
                                {subCategory.name}
                              </Link>
                            }
                          >
                            {subCategory.children
                              .filter(({ numberOfProducts }) => numberOfProducts > 0)
                              .map((cat) => {
                                const slug = getSlug(
                                  `${item.name}${SEPARATOR}${subCategory.name}${SEPARATOR}${cat.name}`,
                                  cat.id
                                )

                                const href = isGloballyPricelist()
                                  ? {
                                      pathname: '/[catalogId]/category/[slug]',
                                      query: { catalogId: query.catalogId, slug },
                                    }
                                  : {
                                      pathname: '/category/[slug]',
                                      query: { slug },
                                    }

                                /* This should have not worked before? */
                                return (
                                  <Link href={href} passHref key={slug} legacyBehavior>
                                    <CwsA hideArrow>{cat.name}</CwsA>
                                  </Link>
                                )
                              })}
                          </CwsHeaderMegamenuItem>
                        )
                      })}
                  </CwsHeaderMegamenu>
                ) : null}
              </CwsHeaderMenuNavItem>
            )
          })}
        </CwsHeaderMenuNav>
      ) : null}
    </>
  )
}
